import React, { useEffect, useRef, useState } from 'react';
import { User } from '../../Entities/User.ts';
import { LoadingAnimation } from '../../Utils/Progress/progress-component';
import { Modal } from '../../Utils/Modal/modal-component';
import { useSelector, useDispatch } from 'react-redux';
import * as authActions from '../../Redux/Auth/AuthActions';
import * as toasActions from '../../Redux/Toast/ToastActions';
import '../Login-Screen/Login.css';
import ThemeToggler from '../../Utils/Theme/theme-toggeler-component';
import { Navigate, useNavigate } from 'react-router';
import idanCover from '../../Assets/signup_img.png'
import Navbar from '../../Utils/Navbar/navbar-component.js';

function SignUp() {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const gsiButton = useRef(null);

    const [notifications, setNotifications] = useState(false);
    const [agreement, setAgreement] = useState(false);
    const [agreedTerms, setAgreedTerms] = useState(false);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [repeatPassword, setRepeatPassword] = useState('');
    const [imageLoaded, setImageLoaded] = useState(false);
    const loading = useSelector((state) => state.loading);
    const signedUp = useSelector((state) => state.auth.signedUp);
    let currentRoute = useSelector((state) => state.auth.currentRoute);
    const userTerms = `
    Thank you for choosing Reciplo! We appreciate your interest in our application. Before you proceed to access and use Reciplo, please carefully read and understand the following Terms of Service. These Terms, together with any other referenced terms and policies, constitute a legally binding agreement between you and Reciplo. By accessing or using the Reciplo application hosted under the domain www.reciplo.com (the "App"), you agree to be bound by these Terms.

    Acceptance of Terms
    By accessing or using the App, you affirm that you have the legal authority to bind yourself, your employer, or any other entity you represent (collectively referred to as "you" or "your") to these Terms. If you do not agree to these Terms or do not have the authority to bind your employer or any other entity, please do not accept these Terms or access or use the App.
    
    Description of Service
    Reciplo provides a platform for users to access and utilize its recipe management and sharing services (the "Service"). The Service is accessible through the App, the website located at www.reciplo.com, and any other means provided by Reciplo. By accepting these Terms, you acknowledge that the term "you" refers to all types of users of the Service, including but not limited to customers, administrators, and individuals representing an employer or entity.
    
    Registration and Account Security
    To access and use certain features of the Service, you may be required to register and create an account. By registering, you agree to provide accurate and current information and to maintain the security of your account credentials. You are solely responsible for all activities that occur under your account and must promptly notify Reciplo of any unauthorized use or security breaches.
    
    Intellectual Property
    Reciplo retains all rights, title, and interest in and to the App, including all intellectual property rights associated with it. You agree not to reproduce, modify, distribute, or create derivative works based on the App or its content without prior written consent from Reciplo.
    
    Third-Party Services and Links
    The App may contain links to third-party websites, services, or resources that are not owned or controlled by Reciplo. Reciplo has no control over and assumes no responsibility for the content, privacy policies, or practices of these third-party services. Your interactions with third-party services are solely between you and the respective third party, and any terms and conditions applicable to those services will govern your use of them.
    
    Limitation of Liability
    To the maximum extent permitted by applicable law, Reciplo and its affiliates shall not be liable for any direct, indirect, incidental, consequential, or special damages arising out of or in any way connected with your use of the App or the Service, even if Reciplo has been advised of the possibility of such damages.
    
    Modifications to the Terms
    Reciplo reserves the right to modify these Terms at any time. Any changes will be effective upon posting the revised Terms on the App. Your continued use of the App after the posting of any modifications constitutes your acceptance of such changes.
    
    Governing Law and Jurisdiction
    These Terms shall be governed by and construed in accordance with the laws of [Jurisdiction]. Any disputes arising out of or relating to these Terms shall be exclusively resolved in the courts of [Jurisdiction].
    
    By accepting these Terms, you confirm that you have read, understood, and agree to be bound by them. If you do not agree with any part of these Terms, please refrain from accessing or using the App.
    
    If you have any questions or concerns about these Terms, please contact us at [contact information].
    
    Effective Date: [date] `;


    useEffect(() => {
        console.log("Modified Terms");
    }, [agreement]);

    useEffect(() => {
        dispatch(authActions.isLoggedIn());
    }, [dispatch]);

    useEffect(() => {
        try {
            window.google.accounts.id.initialize({
                client_id: process.env.REACT_APP_INFRA_GOOGLE_CLIENT_ID,
                callback: (res) => dispatch(authActions.handleSignUpWithGoogle(res)),
                // ux_mode: "redirect"
            });

            window.google.accounts.id.renderButton(
                gsiButton.current,
                { theme: "outline", size: "large", logo_alignment: "center", text: "signup_with", width: 304 }
                //    {theme: "filled_blue", size: "large", logo_alignment: "center", text: "signup_with", width: 304 }
            );

            setTimeout(() => {
                if (currentRoute.toLowerCase() === '/login') {
                    console.log(currentRoute);
                    window.google.accounts.id.prompt();
                }
            }, 2000);
        }
        catch (e) { console.log(e); }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch, gsiButton.current]);


    const handleSubmit = async (e) => {
        e.preventDefault();
        if (password === repeatPassword) {
            const user = new User(email, password);
            dispatch(authActions.signup(user));
        }
        else {
            dispatch(toasActions.setToast('error', 'Passwords do not match'));
        }
    };

    const handleImageLoad = () => {
        setImageLoaded(true);
    };


    <Modal expand={loading.visible}>
        <LoadingAnimation loadingMessage={loading.message} />
    </Modal>

    if (signedUp) {
        const redirectPath = '/login';
        return <Navigate to={redirectPath} replace />
    }

    return (
        <div className='flex justify-center align-middle'>
            <Modal expand={agreement && !agreedTerms}>
                <div className="flex flex-col lg:w-full h-2/3 justify-between max-w-2xl p-6 bg-white border border-gray-200 rounded-lg shadow  dark:bg-gray-800 dark:border-gray-700">
                    <div className="text-lg text-left text-gray-600 dark:text-gray-400 my-2 overflow-y-scroll mx-4 ">
                        {userTerms}
                    </div>
                    <div className="flex justify-center flex-col mb-2">
                        <button
                            onClick={(e) => { setAgreement(true); setAgreedTerms(true); }}
                            className="button-component px-5 my-4" >Accept user agreemenet </button>
                    </div>
                </div>
            </Modal>
            <div className="min-h-full w-full">
                <Navbar isAutoLogOut={false} />
                <div className="flex flex-col lg:flex-row">
                    <div className="flex flex-col lg:flex-row justify-center align-middle">

                        {/* Image Container */}
                        <div className="lg:flex-1 lg:max-w-1/2">
                            <div className="flex justify-center items-center h-full">
                                <img
                                    alt="..."
                                    src={idanCover}
                                    style={{ objectFit: 'cover' }}
                                    className={`${imageLoaded ? 'opacity-100' : 'opacity-0'} rounded-sm transition-all duration-150 `}
                                    onLoad={handleImageLoad}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="lg:px-12 mx-auto lg:flex-1 lg:max-w-1/2">

                        <div className="container-component">
                            <div className="login-header">
                                <div className='flex justify-end align-middle'>
                                    <div className='flex text-6xl text-blue-700 dark:text-gray-50 font-bold py-2 text-right'>הרשמה</div>
                                </div>
                                {/* <div className='font-bold text-lg text-gray-500 dark:text-gray-200'>Join Us!</div> */}
                                <div className='my-1 text-gray-500 dark:text-gray-200 text-right'>הירשמו עכשיו ותתחילו עם קורס 1 מתנה</div>
                            </div>
                            <form onSubmit={handleSubmit}>
                                <div className="login-container">
                                    <div> Email: </div>
                                    <input
                                        className="input-component"
                                        placeholder="user@company.com"
                                        type="text"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        required
                                    />
                                </div>
                                <div className="login-container">
                                    <div> password: </div>
                                    <input
                                        className="input-component"
                                        placeholder="••••••••"
                                        type="password"
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                        required
                                    />
                                </div>
                                <div className="login-container">
                                    <div> repeat password: </div>
                                    <input
                                        className="input-component"
                                        placeholder="••••••••"
                                        type="password"
                                        value={repeatPassword}
                                        onChange={(e) => setRepeatPassword(e.target.value)}
                                        required
                                    />
                                </div>
                                <div className="flex items-start justify-end mb-2 py-2">
                                    <label className="mr-2 text-sm font-medium text-gray-900 dark:text-gray-300">קראתי את התנאים</label>
                                    <div className="flex items-center h-5">
                                        <input type="checkbox" required defaultChecked={agreement && agreedTerms} value={agreement && agreedTerms} onClick={(e) => { setAgreement(!agreement); }} className="w-4 h-4 border border-gray-300 rounded bg-gray-50 focus:ring-3 focus:ring-blue-300 dark:bg-gray-700 dark:border-gray-600 dark:focus:ring-blue-600 dark:ring-offset-gray-800" />
                                    </div>
                                </div>

                                <div className="flex items-start justify-end mb-2">
                                    <label className="mr-2 text-sm font-medium text-gray-900 dark:text-gray-300">אשמח לקבל עדכונים</label>
                                    <div className="flex items-center h-5">
                                        <input type="checkbox" defaultChecked={notifications} value={notifications} onClick={(e) => setNotifications(!notifications)} className="w-4 h-4 border border-gray-300 rounded bg-gray-50 focus:ring-3 focus:ring-blue-300 dark:bg-gray-700 dark:border-gray-600 dark:focus:ring-blue-600 dark:ring-offset-gray-800" />
                                    </div>
                                </div>
                                <div className='flex container mb-2 py-2'>
                                    <button className="button-component" type="submit">הרשמה</button>
                                </div>
                                <div className='flex container mb-5'>
                                    <div ref={gsiButton}></div>
                                </div>
                            </form>
                            <button
                                onClick={(e) => { e.preventDefault(); navigate('/') }}
                                className="w-full inline-flex justify-center text-sm items-center py-2 font-medium text-center text-gray-900 rounded-lg border border-gray-300 hover:bg-gray-100 focus:ring-4 focus:ring-gray-100 dark:text-white dark:border-gray-700 dark:hover:bg-gray-700 dark:focus:ring-gray-800">
                                <svg className=" mr-2 -ml-1 w-5 h-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 25 25" strokeWidth="1.5" stroke="currentColor" ><path strokeLinecap="round" strokeLinejoin="round" d="M9 15L3 9m0 0l6-6M3 9h12a6 6 0 010 12h-3" /></svg>
                                חזרה
                            </button>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default SignUp;